import axios, { AxiosInstance } from 'axios';
import { apiConfig } from '@/config/apiConfig';
import { getVoiceFallbackClient } from './_shared';

// ── Session Intents (/api/intents) — F10, read-only trigger audit trail ──
// RESOLVED (2026-08-21) — real SessionIntentResponse shape confirmed live
// (routes/session_intents.py). The response
// field is `status` (not `state`); `state` is still the query-param name for
// filtering. There is no `session_id` field. `trigger_class` replaces the
// guessed `trigger_source`.

export type SessionIntentStatus =
  | 'pending' | 'gated' | 'scheduled' | 'dialing' | 'in_session' | 'done' | 'rejected' | 'expired';

export type SessionIntent = {
  id: string;
  campaign_id?: string | null;
  campaign_type?: string | null;
  status: SessionIntentStatus;
  trigger_class: string;
  direction: 'inbound' | 'outbound';
  channel_pref: 'pstn' | 'webrtc' | 'either';
  recipient?: Record<string, unknown> | null;
  consent?: Record<string, unknown> | null;
  context?: Record<string, unknown> | null;
  not_before?: string | null;
  expires_at?: string | null;
  priority: number;
  agent_id?: string | null;
  workflow_id?: string | null;
  rejection_reason?: string | null;
  created_at: string;
  updated_at?: string | null;
};

export async function fetchIntents(
  params?: { campaign_id?: string; state?: SessionIntentStatus; skip?: number; limit?: number },
  axiosInstance?: AxiosInstance,
): Promise<SessionIntent[]> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.get<SessionIntent[]>(apiConfig.voiceEndpoints.intents, { params });
  return response.data;
}

export async function fetchIntent(id: string, axiosInstance?: AxiosInstance): Promise<SessionIntent> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.get<SessionIntent>(`${apiConfig.voiceEndpoints.intents}/${id}`);
  return response.data;
}
